import { AnalyticsConnector } from '@amplitude/analytics-connector';

/**
 * @deprecated Update your version of the amplitude analytics-js SDK to 8.17.0+ and for seamless
 * integration with the amplitude analytics SDK.
 */
var AmplitudeUserProvider = /** @class */ (function () {
    function AmplitudeUserProvider(amplitudeInstance) {
        this.amplitudeInstance = amplitudeInstance;
    }
    AmplitudeUserProvider.prototype.getUser = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return {
            device_id: (_b = (_a = this.amplitudeInstance) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.deviceId,
            user_id: (_d = (_c = this.amplitudeInstance) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.userId,
            version: (_f = (_e = this.amplitudeInstance) === null || _e === void 0 ? void 0 : _e.options) === null || _f === void 0 ? void 0 : _f.versionName,
            language: (_h = (_g = this.amplitudeInstance) === null || _g === void 0 ? void 0 : _g.options) === null || _h === void 0 ? void 0 : _h.language,
            platform: (_k = (_j = this.amplitudeInstance) === null || _j === void 0 ? void 0 : _j.options) === null || _k === void 0 ? void 0 : _k.platform,
            os: this.getOs(),
            device_model: this.getDeviceModel(),
        };
    };
    AmplitudeUserProvider.prototype.getOs = function () {
        var _a, _b, _c, _d, _e, _f;
        return [
            (_c = (_b = (_a = this.amplitudeInstance) === null || _a === void 0 ? void 0 : _a._ua) === null || _b === void 0 ? void 0 : _b.browser) === null || _c === void 0 ? void 0 : _c.name,
            (_f = (_e = (_d = this.amplitudeInstance) === null || _d === void 0 ? void 0 : _d._ua) === null || _e === void 0 ? void 0 : _e.browser) === null || _f === void 0 ? void 0 : _f.major,
        ]
            .filter(function (e) { return e !== null && e !== undefined; })
            .join(' ');
    };
    AmplitudeUserProvider.prototype.getDeviceModel = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.amplitudeInstance) === null || _a === void 0 ? void 0 : _a._ua) === null || _b === void 0 ? void 0 : _b.os) === null || _c === void 0 ? void 0 : _c.name;
    };
    return AmplitudeUserProvider;
}());
/**
 * @deprecated Update your version of the amplitude analytics-js SDK to 8.17.0+ and for seamless
 * integration with the amplitude analytics SDK.
 */
var AmplitudeAnalyticsProvider = /** @class */ (function () {
    function AmplitudeAnalyticsProvider(amplitudeInstance) {
        this.amplitudeInstance = amplitudeInstance;
    }
    AmplitudeAnalyticsProvider.prototype.track = function (event) {
        this.amplitudeInstance.logEvent(event.name, event.properties);
    };
    AmplitudeAnalyticsProvider.prototype.setUserProperty = function (event) {
        var _a;
        var _b;
        // if the variant has a value, set the user property and log an event
        this.amplitudeInstance.setUserProperties((_a = {},
            _a[event.userProperty] = (_b = event.variant) === null || _b === void 0 ? void 0 : _b.value,
            _a));
    };
    AmplitudeAnalyticsProvider.prototype.unsetUserProperty = function (event) {
        var _a;
        // if the variant does not have a value, unset the user property
        this.amplitudeInstance['_logEvent']('$identify', null, null, {
            $unset: (_a = {}, _a[event.userProperty] = '-', _a),
        });
    };
    return AmplitudeAnalyticsProvider;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
/** @deprecated */

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
}

function unfetch (e, n) {
  return n = n || {}, new Promise(function (t, r) {
    var s = new XMLHttpRequest(),
        o = [],
        u = [],
        i = {},
        a = function () {
      return {
        ok: 2 == (s.status / 100 | 0),
        statusText: s.statusText,
        status: s.status,
        url: s.responseURL,
        text: function () {
          return Promise.resolve(s.responseText);
        },
        json: function () {
          return Promise.resolve(JSON.parse(s.responseText));
        },
        blob: function () {
          return Promise.resolve(new Blob([s.response]));
        },
        clone: a,
        headers: {
          keys: function () {
            return o;
          },
          entries: function () {
            return u;
          },
          get: function (e) {
            return i[e.toLowerCase()];
          },
          has: function (e) {
            return e.toLowerCase() in i;
          }
        }
      };
    };

    for (var l in s.open(n.method || "get", e, !0), s.onload = function () {
      s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, n, t) {
        o.push(n = n.toLowerCase()), u.push([n, t]), i[n] = i[n] ? i[n] + "," + t : t;
      }), t(a());
    }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers) s.setRequestHeader(l, n.headers[l]);

    s.send(n.body || null);
  });
}

var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : global || self;

/**
 * @packageDocumentation
 * @internal
 */
var fetch = safeGlobal.fetch || unfetch;
/*
 * Copied from:
 * https://github.com/github/fetch/issues/175#issuecomment-284787564
 */
var timeout = function (promise, timeoutMillis) {
    // Don't timeout if timeout is null or invalid
    if (timeoutMillis == null || timeoutMillis <= 0) {
        return promise;
    }
    return new Promise(function (resolve, reject) {
        safeGlobal.setTimeout(function () {
            reject(Error('Request timeout after ' + timeoutMillis + ' milliseconds'));
        }, timeoutMillis);
        promise.then(resolve, reject);
    });
};
var request = function (requestUrl, method, headers, data, timeoutMillis) {
    var call = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, simpleResponse, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetch(requestUrl, {
                        method: method,
                        headers: headers,
                        body: data,
                    })];
                case 1:
                    response = _b.sent();
                    _a = {
                        status: response.status
                    };
                    return [4 /*yield*/, response.text()];
                case 2:
                    simpleResponse = (_a.body = _b.sent(),
                        _a);
                    return [2 /*return*/, simpleResponse];
            }
        });
    }); };
    return timeout(call(), timeoutMillis);
};
var FetchHttpClient = { request: request };

/**
 * Determines the primary source of variants before falling back.
 *
 * @category Source
 */
var Source;
(function (Source) {
    /**
     * The default way to source variants within your application. Before the
     * assignments are fetched, `getVariant(s)` will fallback to local storage
     * first, then `initialVariants` if local storage is empty. This option
     * effectively falls back to an assignment fetched previously.
     */
    Source["LocalStorage"] = "localStorage";
    /**
     * This bootstrap option is used primarily for servers-side rendering using an
     * Experiment server SDK. This bootstrap option always prefers the config
     * `initialVariants` over data in local storage, even if variants are fetched
     * successfully and stored locally.
     */
    Source["InitialVariants"] = "initialVariants";
})(Source || (Source = {}));
/**
 * Indicates from which source the variant() function determines the variant
 *
 * @category Source
 */
var VariantSource;
(function (VariantSource) {
    VariantSource["LocalStorage"] = "storage";
    VariantSource["InitialVariants"] = "initial";
    VariantSource["SecondaryLocalStorage"] = "secondary-storage";
    VariantSource["SecondaryInitialVariants"] = "secondary-initial";
    VariantSource["FallbackInline"] = "fallback-inline";
    VariantSource["FallbackConfig"] = "fallback-config";
})(VariantSource || (VariantSource = {}));
/**
 * Returns true if the VariantSource is one of the fallbacks (inline or config)
 *
 * @param source a {@link VariantSource}
 * @returns true if source is {@link VariantSource.FallbackInline} or {@link VariantSource.FallbackConfig}
 */
var isFallback = function (source) {
    return (source === VariantSource.FallbackInline ||
        source === VariantSource.FallbackConfig ||
        source === VariantSource.SecondaryInitialVariants);
};

/**
 Defaults for Experiment Config options

 | **Option**       | **Default**                       |
 |------------------|-----------------------------------|
 | **debug**        | `false`                           |
 | **instanceName** | `$default_instance` |
 | **fallbackVariant**         | `null`                 |
 | **initialVariants**         | `null`                 |
 | **source** | `Source.LocalStorage` |
 | **serverUrl**    | `"https://api.lab.amplitude.com"` |
 | **assignmentTimeoutMillis**    | `10000` |
 | **retryFailedAssignment**    | `true` |
 | **automaticExposureTracking** | `true` |
 | **automaticFetchOnAmplitudeIdentityChange** | `false` |
 | **userProvider**    | `null` |
 | **analyticsProvider**    | `null` |
 | **exposureTrackingProvider**    | `null` |

 *
 * @category Configuration
 */
var Defaults = {
    debug: false,
    instanceName: '$default_instance',
    fallbackVariant: {},
    initialVariants: {},
    source: Source.LocalStorage,
    serverUrl: 'https://api.lab.amplitude.com',
    fetchTimeoutMillis: 10000,
    retryFetchOnFailure: true,
    automaticExposureTracking: true,
    automaticFetchOnAmplitudeIdentityChange: false,
    userProvider: null,
    analyticsProvider: null,
    exposureTrackingProvider: null,
    httpClient: FetchHttpClient,
};

var version = "1.7.3";

var ConnectorUserProvider = /** @class */ (function () {
    function ConnectorUserProvider(identityStore) {
        this.identityStore = identityStore;
    }
    ConnectorUserProvider.prototype.identityReady = function (ms) {
        return __awaiter(this, void 0, void 0, function () {
            var identity;
            var _this = this;
            return __generator(this, function (_a) {
                identity = this.identityStore.getIdentity();
                if (!identity.userId && !identity.deviceId) {
                    return [2 /*return*/, Promise.race([
                            new Promise(function (resolve) {
                                var listener = function () {
                                    resolve();
                                    _this.identityStore.removeIdentityListener(listener);
                                };
                                _this.identityStore.addIdentityListener(listener);
                            }),
                            new Promise(function (resolve, reject) {
                                safeGlobal.setTimeout(reject, ms, 'Timed out waiting for Amplitude Analytics SDK to initialize. ' +
                                    'You must ensure that the analytics SDK is initialized prior to calling fetch().');
                            }),
                        ])];
                }
                return [2 /*return*/];
            });
        });
    };
    ConnectorUserProvider.prototype.getUser = function () {
        var identity = this.identityStore.getIdentity();
        var userProperties = undefined;
        try {
            userProperties = identity.userProperties;
        }
        catch (_a) {
            console.warn('[Experiment] failed to cast user properties');
        }
        return {
            user_id: identity.userId,
            device_id: identity.deviceId,
            user_properties: userProperties,
        };
    };
    return ConnectorUserProvider;
}());
var ConnectorExposureTrackingProvider = /** @class */ (function () {
    function ConnectorExposureTrackingProvider(eventBridge) {
        this.eventBridge = eventBridge;
    }
    ConnectorExposureTrackingProvider.prototype.track = function (exposure) {
        this.eventBridge.logEvent({
            eventType: '$exposure',
            eventProperties: exposure,
        });
    };
    return ConnectorExposureTrackingProvider;
}());

var DefaultUserProvider = /** @class */ (function () {
    function DefaultUserProvider(applicationContextProvider, userProvider) {
        this.contextProvider = applicationContextProvider;
        this.userProvider = userProvider;
    }
    DefaultUserProvider.prototype.getUser = function () {
        var _a;
        var user = ((_a = this.userProvider) === null || _a === void 0 ? void 0 : _a.getUser()) || {};
        var context = this.contextProvider.getApplicationContext();
        return __assign({ version: context.versionName, language: context.language, platform: context.platform, os: context.os, device_model: context.deviceModel }, user);
    };
    return DefaultUserProvider;
}());

/**
 * @packageDocumentation
 * @internal
 */
var LocalStorage = /** @class */ (function () {
    function LocalStorage(instanceName, apiKey) {
        this.map = {};
        var shortApiKey = apiKey.substring(apiKey.length - 6);
        this.namespace = "amp-exp-" + instanceName + "-" + shortApiKey;
    }
    LocalStorage.prototype.put = function (key, value) {
        this.map[key] = value;
    };
    LocalStorage.prototype.get = function (key) {
        var value = this.map[key];
        if (value === undefined) {
            value = null;
        }
        return value;
    };
    LocalStorage.prototype.clear = function () {
        this.map = {};
    };
    LocalStorage.prototype.remove = function (key) {
        delete this.map[key];
    };
    LocalStorage.prototype.getAll = function () {
        return this.map;
    };
    LocalStorage.prototype.load = function () {
        try {
            var map = JSON.parse(localStorage.getItem(this.namespace)) || {};
            var newMap = {};
            for (var _i = 0, _a = Object.entries(map); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                if (typeof value === 'string') {
                    // old format
                    newMap[key] = { value: value };
                }
                else if (typeof value === 'object') {
                    // new format
                    newMap[key] = {
                        value: value['value'],
                        payload: value['payload'],
                    };
                }
            }
            this.map = newMap;
        }
        catch (e) {
            this.map = {};
        }
    };
    LocalStorage.prototype.save = function () {
        try {
            localStorage.setItem(this.namespace, JSON.stringify(this.map));
        }
        catch (e) {
            // pass
        }
    };
    return LocalStorage;
}());

/**
 * Event for tracking a user's exposure to a variant. This event will not count
 * towards your analytics event volume.
 *
 * @deprecated use ExposureTrackingProvider instead
 */
var exposureEvent = function (user, key, variant, source) {
    var _a;
    var name = '[Experiment] Exposure';
    var value = variant === null || variant === void 0 ? void 0 : variant.value;
    var userProperty = "[Experiment] " + key;
    return {
        name: name,
        user: user,
        key: key,
        variant: variant,
        userProperty: userProperty,
        properties: {
            key: key,
            variant: value,
            source: source,
        },
        userProperties: (_a = {},
            _a[userProperty] = value,
            _a),
    };
};

var isNullOrUndefined = function (value) {
    return value === null || value === undefined;
};

var Backoff = /** @class */ (function () {
    function Backoff(attempts, min, max, scalar) {
        this.started = false;
        this.done = false;
        this.attempts = attempts;
        this.min = min;
        this.max = max;
        this.scalar = scalar;
    }
    Backoff.prototype.start = function (fn) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.started) {
                            this.started = true;
                        }
                        else {
                            throw Error('Backoff already started');
                        }
                        return [4 /*yield*/, this.backoff(fn, 0, this.min)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Backoff.prototype.cancel = function () {
        this.done = true;
        clearTimeout(this.timeoutHandle);
    };
    Backoff.prototype.backoff = function (fn, attempt, delay) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.done) {
                    return [2 /*return*/];
                }
                this.timeoutHandle = safeGlobal.setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    var nextAttempt, nextDelay;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, fn()];
                            case 1:
                                _a.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                _a.sent();
                                nextAttempt = attempt + 1;
                                if (nextAttempt < this.attempts) {
                                    nextDelay = Math.min(delay * this.scalar, this.max);
                                    this.backoff(fn, nextAttempt, nextDelay);
                                }
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }, delay);
                return [2 /*return*/];
            });
        });
    };
    return Backoff;
}());

var fromByteArray_1 = fromByteArray;
var lookup = [];
var revLookup = [];
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
} // Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications


revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];

  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }

  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes

  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3
  // go through the array every three bytes, we'll deal with trailing stuff later

  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  } // pad the end with zeros, but make sure to not forget the extra bytes


  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }

  return parts.join('');
}

var stringToUtf8Array = function (s) {
    var utf8 = unescape(encodeURIComponent(s));
    var arr = [];
    for (var i = 0; i < utf8.length; i++) {
        arr.push(utf8.charCodeAt(i));
    }
    return arr;
};
var urlSafeBase64Encode = function (s) {
    var base64encoded = fromByteArray_1(new Uint8Array(stringToUtf8Array(s)));
    return base64encoded
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
};

var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var randomString = function (length, alphabet) {
    if (alphabet === void 0) { alphabet = CHARS; }
    var str = '';
    for (var i = 0; i < length; ++i) {
        str += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    }
    return str;
};

/**
 * A wrapper for an analytics provider which only sends one exposure event per
 * flag, per variant, per session. In other words, wrapping an analytics
 * provider in this class will prevent the same exposure event to be sent twice
 * in one session.
 */
var SessionAnalyticsProvider = /** @class */ (function () {
    function SessionAnalyticsProvider(analyticsProvider) {
        // In memory record of flagKey and variant value to in order to only set
        // user properties and track an exposure event once per session unless the
        // variant value changes
        this.setProperties = {};
        this.unsetProperties = {};
        this.analyticsProvider = analyticsProvider;
    }
    SessionAnalyticsProvider.prototype.track = function (event) {
        if (this.setProperties[event.key] == event.variant.value) {
            return;
        }
        else {
            this.setProperties[event.key] = event.variant.value;
            delete this.unsetProperties[event.key];
        }
        this.analyticsProvider.track(event);
    };
    SessionAnalyticsProvider.prototype.setUserProperty = function (event) {
        if (this.setProperties[event.key] == event.variant.value) {
            return;
        }
        this.analyticsProvider.setUserProperty(event);
    };
    SessionAnalyticsProvider.prototype.unsetUserProperty = function (event) {
        if (this.unsetProperties[event.key]) {
            return;
        }
        else {
            this.unsetProperties[event.key] = 'unset';
            delete this.setProperties[event.key];
        }
        this.analyticsProvider.unsetUserProperty(event);
    };
    return SessionAnalyticsProvider;
}());

var SessionExposureTrackingProvider = /** @class */ (function () {
    function SessionExposureTrackingProvider(exposureTrackingProvider) {
        this.tracked = {};
        this.exposureTrackingProvider = exposureTrackingProvider;
    }
    SessionExposureTrackingProvider.prototype.track = function (exposure) {
        var trackedExposure = this.tracked[exposure.flag_key];
        if (trackedExposure && trackedExposure.variant === exposure.variant) {
            return;
        }
        else {
            this.tracked[exposure.flag_key] = exposure;
            this.exposureTrackingProvider.track(exposure);
        }
    };
    return SessionExposureTrackingProvider;
}());

/**
 * @packageDocumentation
 * @module experiment-js-client
 */
// Configs which have been removed from the public API.
// May be added back in the future.
var fetchBackoffTimeout = 10000;
var fetchBackoffAttempts = 8;
var fetchBackoffMinMillis = 500;
var fetchBackoffMaxMillis = 10000;
var fetchBackoffScalar = 1.5;
/**
 * The default {@link Client} used to fetch variations from Experiment's
 * servers.
 *
 * @category Core Usage
 */
var ExperimentClient = /** @class */ (function () {
    /**
     * Creates a new ExperimentClient instance.
     *
     * In most cases you will want to use the `initialize` factory method in
     * {@link Experiment}.
     *
     * @param apiKey The Client key for the Experiment project
     * @param config See {@link ExperimentConfig} for config options
     */
    function ExperimentClient(apiKey, config) {
        this.user = null;
        /**
         * @deprecated
         */
        this.userProvider = null;
        this.apiKey = apiKey;
        this.config = __assign(__assign({}, Defaults), config);
        if (this.config.userProvider) {
            this.userProvider = this.config.userProvider;
        }
        if (this.config.analyticsProvider) {
            this.analyticsProvider = new SessionAnalyticsProvider(this.config.analyticsProvider);
        }
        if (this.config.exposureTrackingProvider) {
            this.exposureTrackingProvider = new SessionExposureTrackingProvider(this.config.exposureTrackingProvider);
        }
        this.httpClient = this.config.httpClient;
        this.storage = new LocalStorage(this.config.instanceName, apiKey);
        this.storage.load();
    }
    /**
     * Assign the given user to the SDK and asynchronously fetch all variants
     * from the server. Subsequent calls may omit the user from the argument to
     * use the user from the previous call.
     *
     * If an {@link ExperimentUserProvider} has been set, the argument user will
     * be merged with the provider user, preferring user fields from the argument
     * user and falling back on the provider for fields which are null or
     * undefined.
     *
     * If configured, fetch retries the request in the background on failure.
     * Variants received from a successful retry are stored in local storage for
     * access.
     *
     * If you are using the `initialVariants` config option to pre-load this SDK
     * from the server, you generally do not need to call `fetch`.
     *
     * @param user The user to fetch variants for.
     * @returns Promise that resolves when the request for variants completes.
     * @see ExperimentUser
     * @see ExperimentUserProvider
     */
    ExperimentClient.prototype.fetch = function (user, options) {
        if (user === void 0) { user = this.user; }
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setUser(user || {});
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchInternal(user, this.config.fetchTimeoutMillis, this.config.retryFetchOnFailure, options)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, this];
                }
            });
        });
    };
    /**
     * Returns the variant for the provided key.
     *
     * Access the variant from {@link Source}, falling back  on the given
     * fallback, then the configured fallbackVariant.
     *
     * If an {@link ExperimentAnalyticsProvider} is configured and trackExposure is
     * true, this function will call the provider with an {@link ExposureEvent}.
     * The exposure event does not count towards your event volume within Amplitude.
     *
     * @param key The key to get the variant for.
     * @param fallback The highest priority fallback.
     * @see ExperimentConfig
     * @see ExperimentAnalyticsProvider
     */
    ExperimentClient.prototype.variant = function (key, fallback) {
        if (!this.apiKey) {
            return { value: undefined };
        }
        var _a = this.variantAndSource(key, fallback), source = _a.source, variant = _a.variant;
        if (this.config.automaticExposureTracking) {
            this.exposureInternal(key, variant, source);
        }
        this.debug("[Experiment] variant for " + key + " is " + variant.value);
        return variant;
    };
    /**
     * Track an exposure event for the variant associated with the flag/experiment
     * {@link key}.
     *
     * This method requires that an {@link ExperimentAnalyticsProvider} be
     * configured when this client is initialized, either manually, or through the
     * Amplitude Analytics SDK integration from set up using
     * {@link Experiment.initializeWithAmplitudeAnalytics}.
     *
     * @param key The flag/experiment key to track an exposure for.
     */
    ExperimentClient.prototype.exposure = function (key) {
        var _a = this.variantAndSource(key, null), source = _a.source, variant = _a.variant;
        this.exposureInternal(key, variant, source);
    };
    /**
     * Returns all variants for the user.
     *
     * The primary source of variants is based on the
     * {@link Source} configured in the {@link ExperimentConfig}.
     *
     * @see Source
     * @see ExperimentConfig
     */
    ExperimentClient.prototype.all = function () {
        if (!this.apiKey) {
            return {};
        }
        return __assign(__assign({}, this.secondaryVariants()), this.sourceVariants());
    };
    /**
     * Clear all variants in the cache and storage.
     *
     */
    ExperimentClient.prototype.clear = function () {
        this.storage.clear();
        this.storage.save();
    };
    /**
     * Get a copy of the internal {@link ExperimentUser} object if it is set.
     *
     * @returns a copy of the internal user object if set.
     */
    ExperimentClient.prototype.getUser = function () {
        var _a;
        if (!this.user) {
            return this.user;
        }
        if ((_a = this.user) === null || _a === void 0 ? void 0 : _a.user_properties) {
            var userPropertiesCopy = __assign({}, this.user.user_properties);
            return __assign(__assign({}, this.user), { user_properties: userPropertiesCopy });
        }
        else {
            return __assign({}, this.user);
        }
    };
    /**
     * Copy in and set the user within the experiment client.
     *
     * @param user the user to set within the experiment client.
     */
    ExperimentClient.prototype.setUser = function (user) {
        var _a;
        if (!user) {
            this.user = null;
            return;
        }
        if ((_a = this.user) === null || _a === void 0 ? void 0 : _a.user_properties) {
            var userPropertiesCopy = __assign({}, user.user_properties);
            this.user = __assign(__assign({}, user), { user_properties: userPropertiesCopy });
        }
        else {
            this.user = __assign({}, user);
        }
    };
    /**
     * Get the user provider set by {@link setUserProvider} or null if the user
     * provider has not been set.
     *
     * @returns The user provider set by {@link setUserProvider} or null.
     * @deprecated use ExperimentConfig.userProvider instead
     */
    ExperimentClient.prototype.getUserProvider = function () {
        return this.userProvider;
    };
    /**
     * Sets a user provider that will inject identity information into the user
     * for {@link fetch()} requests. The user provider will only set user fields
     * in outgoing requests which are null or undefined.
     *
     * See {@link ExperimentUserProvider} for more details
     * @param userProvider
     * @deprecated use ExperimentConfig.userProvider instead
     */
    ExperimentClient.prototype.setUserProvider = function (userProvider) {
        this.userProvider = userProvider;
        return this;
    };
    ExperimentClient.prototype.variantAndSource = function (key, fallback) {
        if (this.config.source === Source.InitialVariants) {
            // for source = InitialVariants, fallback order goes:
            // 1. InitialFlags
            // 2. Local Storage
            // 3. Function fallback
            // 4. Config fallback
            var sourceVariant = this.sourceVariants()[key];
            if (!isNullOrUndefined(sourceVariant)) {
                return {
                    variant: this.convertVariant(sourceVariant),
                    source: VariantSource.InitialVariants,
                };
            }
            var secondaryVariant = this.secondaryVariants()[key];
            if (!isNullOrUndefined(secondaryVariant)) {
                return {
                    variant: this.convertVariant(secondaryVariant),
                    source: VariantSource.SecondaryLocalStorage,
                };
            }
            if (!isNullOrUndefined(fallback)) {
                return {
                    variant: this.convertVariant(fallback),
                    source: VariantSource.FallbackInline,
                };
            }
            return {
                variant: this.convertVariant(this.config.fallbackVariant),
                source: VariantSource.FallbackConfig,
            };
        }
        else {
            // for source = LocalStorage, fallback order goes:
            // 1. Local Storage
            // 2. Function fallback
            // 3. InitialFlags
            // 4. Config fallback
            var sourceVariant = this.sourceVariants()[key];
            if (!isNullOrUndefined(sourceVariant)) {
                return {
                    variant: this.convertVariant(sourceVariant),
                    source: VariantSource.LocalStorage,
                };
            }
            if (!isNullOrUndefined(fallback)) {
                return {
                    variant: this.convertVariant(fallback),
                    source: VariantSource.FallbackInline,
                };
            }
            var secondaryVariant = this.secondaryVariants()[key];
            if (!isNullOrUndefined(secondaryVariant)) {
                return {
                    variant: this.convertVariant(secondaryVariant),
                    source: VariantSource.SecondaryInitialVariants,
                };
            }
            return {
                variant: this.convertVariant(this.config.fallbackVariant),
                source: VariantSource.FallbackConfig,
            };
        }
    };
    ExperimentClient.prototype.fetchInternal = function (user, timeoutMillis, retry, options) {
        return __awaiter(this, void 0, void 0, function () {
            var variants, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Don't even try to fetch variants if API key is not set
                        if (!this.apiKey) {
                            throw Error('Experiment API key is empty');
                        }
                        this.debug("[Experiment] Fetch all: retry=" + retry);
                        // Proactively cancel retries if active in order to avoid unecessary API
                        // requests. A new failure will restart the retries.
                        if (retry) {
                            this.stopRetries();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.doFetch(user, timeoutMillis, options)];
                    case 2:
                        variants = _a.sent();
                        this.storeVariants(variants, options);
                        return [2 /*return*/, variants];
                    case 3:
                        e_2 = _a.sent();
                        if (retry) {
                            this.startRetries(user, options);
                        }
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ExperimentClient.prototype.doFetch = function (user, timeoutMillis, options) {
        return __awaiter(this, void 0, void 0, function () {
            var userContext, encodedContext, queryString, endpoint, headers, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addContextOrWait(user, 10000)];
                    case 1:
                        userContext = _a.sent();
                        encodedContext = urlSafeBase64Encode(JSON.stringify(userContext));
                        queryString = '';
                        if (this.config.debug) {
                            queryString = "?d=" + randomString(8);
                        }
                        endpoint = this.config.serverUrl + "/sdk/vardata" + queryString;
                        headers = {
                            Authorization: "Api-Key " + this.apiKey,
                            'X-Amp-Exp-User': encodedContext,
                        };
                        if (options && options.flagKeys) {
                            headers['X-Amp-Exp-Flag-Keys'] = urlSafeBase64Encode(JSON.stringify(options.flagKeys));
                        }
                        this.debug('[Experiment] Fetch variants for user: ', userContext);
                        return [4 /*yield*/, this.httpClient.request(endpoint, 'GET', headers, null, timeoutMillis)];
                    case 2:
                        response = _a.sent();
                        if (response.status != 200) {
                            throw Error("Fetch error response: status=" + response.status);
                        }
                        this.debug('[Experiment] Received fetch response: ', response);
                        return [2 /*return*/, this.parseResponse(response)];
                }
            });
        });
    };
    ExperimentClient.prototype.parseResponse = function (response) {
        var json = JSON.parse(response.body);
        var variants = {};
        for (var _i = 0, _a = Object.keys(json); _i < _a.length; _i++) {
            var key = _a[_i];
            variants[key] = {
                value: json[key].key,
                payload: json[key].payload,
            };
        }
        this.debug('[Experiment] Received variants: ', variants);
        return variants;
    };
    ExperimentClient.prototype.storeVariants = function (variants, options) {
        var failedFlagKeys = options && options.flagKeys ? options.flagKeys : [];
        if (failedFlagKeys.length === 0) {
            this.storage.clear();
        }
        var _loop_1 = function (key) {
            failedFlagKeys = failedFlagKeys.filter(function (flagKey) { return flagKey !== key; });
            this_1.storage.put(key, variants[key]);
        };
        var this_1 = this;
        for (var key in variants) {
            _loop_1(key);
        }
        for (var key in failedFlagKeys) {
            this.storage.remove(key);
        }
        this.storage.save();
        this.debug('[Experiment] Stored variants: ', variants);
    };
    ExperimentClient.prototype.startRetries = function (user, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.debug('[Experiment] Retry fetch');
                this.retriesBackoff = new Backoff(fetchBackoffAttempts, fetchBackoffMinMillis, fetchBackoffMaxMillis, fetchBackoffScalar);
                this.retriesBackoff.start(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.fetchInternal(user, fetchBackoffTimeout, false, options)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ExperimentClient.prototype.stopRetries = function () {
        if (this.retriesBackoff != null) {
            this.retriesBackoff.cancel();
        }
    };
    ExperimentClient.prototype.addContext = function (user) {
        var _a, _b;
        var providedUser = (_a = this.userProvider) === null || _a === void 0 ? void 0 : _a.getUser();
        var mergedUserProperties = __assign(__assign({}, user === null || user === void 0 ? void 0 : user.user_properties), providedUser === null || providedUser === void 0 ? void 0 : providedUser.user_properties);
        return __assign(__assign(__assign({ library: "experiment-js-client/" + version }, (_b = this.userProvider) === null || _b === void 0 ? void 0 : _b.getUser()), user), { user_properties: mergedUserProperties });
    };
    ExperimentClient.prototype.addContextOrWait = function (user, ms) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.userProvider instanceof DefaultUserProvider)) return [3 /*break*/, 2];
                        if (!(this.userProvider.userProvider instanceof ConnectorUserProvider)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userProvider.userProvider.identityReady(ms)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.addContext(user)];
                }
            });
        });
    };
    ExperimentClient.prototype.convertVariant = function (value) {
        if (value === null || value === undefined) {
            return {};
        }
        if (typeof value == 'string') {
            return {
                value: value,
            };
        }
        else {
            return value;
        }
    };
    ExperimentClient.prototype.sourceVariants = function () {
        if (this.config.source == Source.LocalStorage) {
            return this.storage.getAll();
        }
        else if (this.config.source == Source.InitialVariants) {
            return this.config.initialVariants;
        }
    };
    ExperimentClient.prototype.secondaryVariants = function () {
        if (this.config.source == Source.LocalStorage) {
            return this.config.initialVariants;
        }
        else if (this.config.source == Source.InitialVariants) {
            return this.storage.getAll();
        }
    };
    ExperimentClient.prototype.exposureInternal = function (key, variant, source) {
        var _a, _b, _c, _d, _e, _f, _g;
        var user = this.addContext(this.getUser());
        var event = exposureEvent(user, key, variant, source);
        if (isFallback(source) || !(variant === null || variant === void 0 ? void 0 : variant.value)) {
            // fallbacks indicate not being allocated into an experiment, so
            // we can unset the property
            (_a = this.exposureTrackingProvider) === null || _a === void 0 ? void 0 : _a.track({ flag_key: key });
            (_c = (_b = this.analyticsProvider) === null || _b === void 0 ? void 0 : _b.unsetUserProperty) === null || _c === void 0 ? void 0 : _c.call(_b, event);
        }
        else if (variant === null || variant === void 0 ? void 0 : variant.value) {
            // only track when there's a value for a non fallback variant
            (_d = this.exposureTrackingProvider) === null || _d === void 0 ? void 0 : _d.track({
                flag_key: key,
                variant: variant.value,
            });
            (_f = (_e = this.analyticsProvider) === null || _e === void 0 ? void 0 : _e.setUserProperty) === null || _f === void 0 ? void 0 : _f.call(_e, event);
            (_g = this.analyticsProvider) === null || _g === void 0 ? void 0 : _g.track(event);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ExperimentClient.prototype.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.config.debug) {
            console.debug.apply(console, __spreadArrays([message], optionalParams));
        }
    };
    return ExperimentClient;
}());

var instances = {};
/**
 * Initializes a singleton {@link ExperimentClient} identified by the configured
 * instance name.
 *
 * @param apiKey The deployment API Key
 * @param config See {@link ExperimentConfig} for config options
 */
var initialize = function (apiKey, config) {
    // Store instances by appending the instance name and api key. Allows for
    // initializing multiple default instances for different api keys.
    var instanceName = (config === null || config === void 0 ? void 0 : config.instanceName) || Defaults.instanceName;
    var instanceKey = instanceName + "." + apiKey;
    var connector = AnalyticsConnector.getInstance(instanceName);
    if (!instances[instanceKey]) {
        config = __assign({ userProvider: new DefaultUserProvider(connector.applicationContextProvider, config === null || config === void 0 ? void 0 : config.userProvider) }, config);
        instances[instanceKey] = new ExperimentClient(apiKey, config);
    }
    return instances[instanceKey];
};
/**
 * Initialize a singleton {@link ExperimentClient} which automatically
 * integrates with the installed and initialized instance of the amplitude
 * analytics SDK.
 *
 * You must be using amplitude-js SDK version 8.17.0+ for this integration to
 * work.
 *
 * @param apiKey The deployment API Key
 * @param config See {@link ExperimentConfig} for config options
 */
var initializeWithAmplitudeAnalytics = function (apiKey, config) {
    // Store instances by appending the instance name and api key. Allows for
    // initializing multiple default instances for different api keys.
    var instanceName = (config === null || config === void 0 ? void 0 : config.instanceName) || Defaults.instanceName;
    var instanceKey = instanceName + "." + apiKey;
    var connector = AnalyticsConnector.getInstance(instanceName);
    if (!instances[instanceKey]) {
        config = __assign({ userProvider: new DefaultUserProvider(connector.applicationContextProvider, new ConnectorUserProvider(connector.identityStore)), exposureTrackingProvider: new ConnectorExposureTrackingProvider(connector.eventBridge) }, config);
        instances[instanceKey] = new ExperimentClient(apiKey, config);
        if (config.automaticFetchOnAmplitudeIdentityChange) {
            connector.identityStore.addIdentityListener(function () {
                instances[instanceKey].fetch();
            });
        }
    }
    return instances[instanceKey];
};
/**
 * Provides factory methods for storing singleton instances of {@link ExperimentClient}
 * @category Core Usage
 */
var Experiment = {
    initialize: initialize,
    initializeWithAmplitudeAnalytics: initializeWithAmplitudeAnalytics,
};

/**
 * A stub {@link Client} implementation that does nothing for all methods
 */
var StubExperimentClient = /** @class */ (function () {
    function StubExperimentClient() {
    }
    StubExperimentClient.prototype.getUser = function () {
        return {};
    };
    StubExperimentClient.prototype.setUser = function (user) { };
    StubExperimentClient.prototype.fetch = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this];
            });
        });
    };
    StubExperimentClient.prototype.getUserProvider = function () {
        return null;
    };
    StubExperimentClient.prototype.setUserProvider = function (uerProvider) {
        return this;
    };
    StubExperimentClient.prototype.variant = function (key, fallback) {
        return Defaults.fallbackVariant;
    };
    StubExperimentClient.prototype.all = function () {
        return {};
    };
    StubExperimentClient.prototype.clear = function () { };
    StubExperimentClient.prototype.exposure = function (key) { };
    return StubExperimentClient;
}());

export { AmplitudeAnalyticsProvider, AmplitudeUserProvider, Experiment, ExperimentClient, Source, StubExperimentClient };
